import { ImageList } from "@mui/material";
import { Theme } from '@mui/material/styles';
import { createStyles, withStyles, WithStyles } from "@mui/styles";
import { GlobalClassKeys } from "assets/jss/common-styles";
import classNames from "classnames";
import DashDoughnutBox, { DashDoughnutProps } from "components/Dashboard/DashDoughnutBox";
import * as React from "react";

const styles = (theme: Theme) => createStyles({
    gridList: {
        display: "flex",
        flexWrap: 'nowrap',
        // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
        transform: 'translateZ(0)',
        justifyContent: "flex-start",
        paddingBottom: "4px"
    },
});


export type DashDoughnutBoxListItem = Omit<DashDoughnutProps, "color" | "active" | "onClick">;

export interface DashListProps {
    active: any;
    color: "primary" | "secondary" | "error" | "info" | "success" | "warning" | "muted";
    boxes: DashDoughnutBoxListItem[];
    onClick: (key: any) => void;
}


type Props = DashListProps & WithStyles<typeof styles>;

const DashDoughnutListBox: React.FC<Props> = (props) => {

    let gridRef: HTMLUListElement;

    const { active, color, classes, onClick } = props;

    return (
        <ImageList ref={(ref: HTMLUListElement) => gridRef = ref} className={classNames(classes.gridList, GlobalClassKeys.thinScroll)} cols={2.5} >
            {
                props.boxes.map((v, index) => <DashDoughnutBox
                    key={index}
                    color={color}
                    active={v.key == active}
                    onClick={
                        (e) => {
                            var container = gridRef.getBoundingClientRect();
                            var el = e.currentTarget.getBoundingClientRect();
                            gridRef.scrollTo({
                                left: el.left + el.width - container.left - container.width + gridRef.scrollLeft,
                                behavior: 'smooth'
                            });

                            onClick(v.key);
                        }
                    }
                    {...v}
                />)
            }
        </ImageList>
    );
};


export default withStyles(styles)(DashDoughnutListBox);
